
export const FallbackComponent = () => <div className="app-body-lazy"></div>;